import type { EventsMap } from '@noths/polaris-client-next-redux';
import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';
import { isBrowser } from '@noths/polaris-client-utils';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { requestProducts } from 'src/redux/products/thunks/requestProducts';
import { sendMiraklListingViewBeacon } from 'src/tracking/mirakl/sendMiraklListingViewBeacon';

/**
 * The first page of results is sent from the server. Every later result set (page change, facet or
 * sort change, taxonomy navigation) only reaches the store in the browser, so it goes by beacon to
 * this app's own route, which applies the consent and robot rules. Bots are skipped here as well
 * so they cost nothing.
 */
export const miraklEventsMap: EventsMap<ReduxApplicationState> = {
  [requestProducts.fulfilled.type]: (_prevState, nextState) => {
    if (isBrowser() && !nextState.user.bot) {
      sendMiraklListingViewBeacon(nextState);
    }
  },
};

export const MiraklMiddleware =
  createMiddlewareFromEventsMap<ReduxApplicationState>(miraklEventsMap);
